import React, { useEffect } from "react";
import styles from "./Print.module.css";

import { useReactToPrint } from "react-to-print";
import Button from "../components/Button";
import { symbol } from "prop-types";
//import { ComponentToPrint } from "../ComponentToPrint";

function PrintEventFOH({ eventData, serverData }) {
  const componentRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const test = eventData;

  const parser = new DOMParser();

  const getTimeValue = (aDate) => {
    // console.log(eventData.length);
    // if (Object.keys(eventData.length == 0)) {
    //   return;
    // }
    if (!aDate) {
      return;
    }

    let hours;
    let minutes;
    if (aDate.length == 8) {
      hours = Number(aDate.substring(0, 2));
      minutes = Number(aDate.substring(3, 5));
    } else {
      let theDate = new Date(aDate.slice(0, -1));
      hours = theDate.getHours();
      minutes = theDate.getMinutes();
    }

    if (hours != 0) {
      return `${hours > 12 ? hours - 12 : hours}:${minutes < 10 ? "0" + minutes : minutes} ${hours >= 12 ? "pm" : "am"}`;
    }
  };

  const apps = eventData.details.filter((el) => el.Category == "APP" || el.Category == "APP_IT" || el.Category == "APP_ADD");
  const ents = eventData.details.filter(
    (el) =>
      el.Category == "ENT" ||
      el.Category == "BUF" ||
      el.Category == "BUF_IT" ||
      el.Category == "BUF_ADD" ||
      el.Category == "DIN_ADD" ||
      el.Category == "DIN_IT" ||
      el.Category == "SIDE"
  );
  const dess = eventData.details.filter((el) => el.Category == "DES");
  const bevs = eventData.details.filter((el) => el.Category == "BEV" || el.Category == "BEV-NA");

  const banquetTotal =
    Number(eventData.fbTotal) +
    Number(eventData.barTotal) +
    //Number(eventData.serviceTotal) +
    Number(eventData.otherTotal) +
    Number(eventData.RoomCharge);
  //Number(eventData.addlGrat);

  useEffect(() => {
    reactToPrintFn();
  }, []);

  return (
    <>
      <div className="printOnly">
        <div ref={contentRef}>
          <div className={styles.printFrame}>
            <div className={`${styles.printSection1of1} ${styles.center} ${styles.pt1}`}>
              <span className={styles.titleBox}>FOH</span>
            </div>
            <div className={styles.printContent}>
              {/* Header Area */}
              <div className={`${styles.printSection1of2}`}>
                <h3>EVENT: {eventData.BanquetName}</h3>
              </div>
              <div className={`${styles.printSection1of2} ${styles.right}`}>
                <h3>EVENT DATE: {new Date(eventData.BanDate.replace("Z", "")).toDateString()}</h3>
              </div>
            </div>
            <hr className={`${styles.printSection1of1} ${styles.my1}`} />
            <div className={styles.flexSection}>
              <div className={styles.printSection1of3}>
                <div className={styles.contactInfo}>
                  <h5>Contact Info</h5>
                  <p>{eventData.FirstName + " " + eventData.LastName}</p>
                  {eventData.CompanyName && eventData.CompanyName.length > 0 ? <p>{eventData.CompanyName}</p> : ""}
                </div>
                <div className={styles.eventInfo}></div>
                <div className={styles.serverInfo}></div>
              </div>
              <div className={styles.printSection1of3}>
                <div className={styles.contactInfo}>
                  <h5>Event Details</h5>
                  <table className={styles.timeTable}>
                    <tbody>
                      <tr>
                        <td>Arrival</td>
                        <td>{getTimeValue(eventData.BanArrivalTime)}</td>
                      </tr>
                      <tr>
                        <td>Apps</td>
                        <td>{getTimeValue(eventData.AppTime)}</td>
                      </tr>
                      <tr>
                        <td>Entrees</td>
                        <td>{getTimeValue(eventData.BanMealTime)}</td>
                      </tr>
                      <tr>
                        <td>Dessert</td>
                        <td>{getTimeValue(eventData.DessertTime)}</td>
                      </tr>
                      <tr>
                        <td>Departure</td>
                        <td>{getTimeValue(eventData.DepartureTime)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className={`${styles.printSection1of3} ${styles.right}`}>
                <div className={styles.serverInfo}>
                  <h5>Servers</h5>
                  {serverData.map((sd) => {
                    if (sd.category == "Server") {
                      return <p key={sd.ServerName}>{sd.ServerName}</p>;
                    }
                  })}
                </div>
              </div>
            </div>
            <hr className={`${styles.printSection1of1} ${styles.my1}`} />
            <div className={styles.flexSection}>
              <div className={`${styles.printSection1of1} ${styles.printContent}`}>
                <div className={styles.printSection1of3}>
                  Guest Count: <b>{eventData.BanAttendance}</b>
                </div>
                <div className={`${styles.printSection1of3} ${styles.center}`}>
                  Banquet Room: <b>{eventData.RoomName}</b>
                </div>
                <div className={`${styles.printSection1of3} ${styles.right}`}>
                  Service Type: <b>{eventData.ServiceTypeName}</b>
                </div>
              </div>
            </div>
            <hr className={`${styles.printSection1of1} ${styles.my1}`} />
            <div className={`${styles.printSection1of1} ${styles.pageBreak} ${styles.mb1}`}>
              <h5>Setup Notes:</h5>
              <div style={{ whiteSpace: "pre-line" }}>{String(eventData.setupNotes)}</div>
            </div>
            <div className={`${styles.printSection1of1}  ${styles.mb1} ${styles.pageBreak}`}>
              <h5>Event Notes:</h5>
              <div style={{ whiteSpace: "pre-line" }}>{String(eventData.EventNotes)}</div>
            </div>

            <hr className={`${styles.printSection1of1} ${styles.my1}`} />

            <div className={`${styles.printSection1of1}`}>
              <h5 className={styles.mb1}>Item Detail</h5>
              <table className={`${styles.table} ${styles.table_3}`}>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(eventData.details) &&
                    eventData.details
                      .filter((it) => it.Category != "ONF")
                      .map((bd, index) => {
                        let subTotal = bd.isPricePer
                          ? Number(bd.qty * eventData.BanAttendance * (bd.Price + bd.addOnPrice)).toFixed(2)
                          : Number(bd.qty * (bd.Price + bd.addOnPrice)).toFixed(2);
                        if (bd.isParent == true || bd.Category.endsWith("_ADD")) {
                          if (bd.Category.endsWith("_ADD")) {
                            return (
                              <tr>
                                <td>
                                  --ADDON: {bd.item} ({bd.qty * eventData.BanAttendance} @ ${bd.Price})
                                </td>
                                <td></td>
                                <td></td>
                              </tr>
                            );
                          } else {
                            return (
                              <tr>
                                <td>{bd.item}</td>
                                <td>{bd.isPricePer ? bd.qty * eventData.BanAttendance : bd.qty}</td>
                                <td>{Number(subTotal).toFixed(2)}</td>
                              </tr>
                            );
                          }
                        }
                      })}
                  {Array.isArray(eventData.details) &&
                    eventData.details
                      .filter((it) => it.Category == "ONF")
                      .map((bd, index) => {
                        return (
                          <tr>
                            <td>{bd.item}</td>
                            <td></td>
                            <td>{Number(bd.Price).toFixed(2)}</td>
                          </tr>
                        );
                      })}
                  <tr>
                    <td>Room Charge</td>
                    <td></td>
                    <td>{Number(eventData.RoomCharge).toFixed(2)}</td>
                  </tr>
                  <tr className={styles.totalRow}>
                    <td>Sales Total</td>
                    <td></td>
                    <td>{Number(banquetTotal).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Deposit</td>
                    <td></td>
                    <td>-{Number(eventData.Deposit).toFixed(2)}</td>
                  </tr>
                  <tr className={`${styles.totalRow} ${styles.totalRowBoxed}`}>
                    <td>Amount Due</td>
                    <td></td>
                    <td>{Number(banquetTotal - eventData.Deposit).toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className={`${styles.printSection1of1} ${styles.flexSectionColumn} ${styles.my1} ${styles.pageBreak}`}>
              <h4 className={`${styles.mb1}`}>Kitchen Menu Notes:</h4>
              <div className={`${styles.printSection1of1} ${styles.borderedDiv}`}>
                <table className={`${styles.notesTable}`}>
                  <thead>
                    <tr>
                      <th>
                        <h4>
                          APPS: <span style={{ marginLeft: 1 + "rem" }}>{getTimeValue(eventData.AppTime)}</span>
                        </h4>
                      </th>
                      <th>Qty</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apps.length > 0 ? (
                      apps.map((el) => {
                        if (el.menuLocation) {
                          return (
                            <tr>
                              <td>{el.isParent ? el.item : <span className={styles.subItem}>{el.item}</span>}</td>
                              <td>{el.isPricePer ? `(${el.qty * eventData.BanAttendance}x)` : el.qty}</td>
                              <td>
                                <pre>{String(el.menuItemNotes) != "null" ? String(el.menuItemNotes) : ""}</pre>
                              </td>
                            </tr>
                          );
                        }
                      })
                    ) : (
                      <tr>
                        <td>No Apps</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <table className={`${styles.notesTable}`}>
                  <thead>
                    <tr>
                      <th>
                        <h4>
                          ENTREES: <span style={{ marginLeft: 1 + "rem" }}>{getTimeValue(eventData.BanMealTime)}</span>
                        </h4>
                      </th>
                      <th>Qty</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ents.length > 0 ? (
                      ents.map((el) => {
                        if (el.menuLocation) {
                          return (
                            <tr>
                              <td>{el.isParent ? el.item : <span className={styles.subItem}>{el.item}</span>}</td>
                              <td>{el.isPricePer && !el.isParent ? `${el.qty * eventData.BanAttendance}` : el.qty}</td>
                              <td>
                                <pre>{String(el.menuItemNotes) != "null" ? String(el.menuItemNotes) : ""}</pre>
                              </td>
                            </tr>
                          );
                        }
                      })
                    ) : (
                      <tr>
                        <td>No Entrees</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <table className={`${styles.notesTable}`}>
                  <thead>
                    <tr>
                      <th>
                        <h4>
                          DESSERTS: <span style={{ marginLeft: 1 + "rem" }}>{getTimeValue(eventData.DessertTime)}</span>
                        </h4>
                      </th>
                      <th>Qty</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dess.length > 0 ? (
                      dess.map((el) => {
                        return (
                          <tr>
                            <td>{el.isParent ? el.item : <span className={styles.subItem}>{el.item}</span>}</td>
                            <td>{el.isPricePer ? `(${el.qty * eventData.BanAttendance}x)` : el.qty}</td>
                            <td>
                              <pre>{String(el.menuItemNotes) != "null" ? String(el.menuItemNotes) : ""}</pre>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>No Desserts</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <table className={`${styles.notesTable} ${styles.pageBreak}`}>
                  <thead>
                    <tr>
                      <th>
                        <h4>
                          BEVERAGES: <span style={{ marginLeft: 1 + "rem" }}></span>
                        </h4>
                      </th>
                      <th>Qty</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bevs.length > 0 ? (
                      bevs.map((el) => {
                        return (
                          <tr>
                            <td>{el.item}</td>
                            <td>{el.qty}</td>
                            <td>
                              <pre>{String(el.menuItemNotes) != "null" ? String(el.menuItemNotes) : ""}</pre>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>No Beverages</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Button type="secondary" onClick={() => reactToPrintFn()}>
        Print Event Detail FOH
      </Button> */}
    </>
  );
}

export default PrintEventFOH;
